import { useState } from 'react'
import { Modal, Notice } from './ui'

/**
 * ConfirmDialog is the double-confirm gate for destructive or irreversible
 * actions. `expectText` forces the operator to type it (撤回/清空 cannot be
 * triggered by a stray click). On failure the dialog stays open so the caller
 * can retry with the SAME idempotency key instead of starting a new write.
 */
export function ConfirmDialog({
  title,
  description,
  expectText,
  confirmLabel = '确认执行',
  extraLabel,
  extraTitle,
  onExtra,
  copyLabel,
  onCopy,
  busy,
  error,
  onConfirm,
  onClose,
  children,
}: {
  title: string
  description: string
  expectText?: string
  confirmLabel?: string
  extraLabel?: string
  extraTitle?: string
  onExtra?: () => void
  copyLabel?: string
  onCopy?: () => void
  busy: boolean
  error: unknown
  onConfirm: () => void
  onClose: () => void
  children?: React.ReactNode
}) {
  const [typed, setTyped] = useState('')
  const blocked = (expectText !== undefined && typed !== expectText) || busy

  return (
    <Modal title={title} onClose={busy ? () => undefined : onClose} width={560}>
      <p className="lead">{description}</p>
      {children}
      {error ? <Notice error={error} /> : null}
      {expectText !== undefined && (
        <label className="field">
          <span>
            请输入 <code>{expectText}</code> 以确认
          </span>
          <input value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off" />
        </label>
      )}
      <div className="row end">
        <button type="button" onClick={onClose} disabled={busy}>
          取消
        </button>
        {onCopy && copyLabel && (
          <button type="button" onClick={onCopy} disabled={busy}>
            {copyLabel}
          </button>
        )}
        {onExtra && extraLabel && (
          <button type="button" onClick={onExtra} disabled={blocked} title={extraTitle}>
            {extraLabel}
          </button>
        )}
        {/* 不需要打字确认时，焦点直接落在确认键上：回车即执行，不用摸鼠标。
            需要打字时反过来，焦点在输入框，确认键在打对之前是禁用的。 */}
        <button
          type="button"
          className="danger"
          onClick={onConfirm}
          disabled={blocked}
          {...(expectText === undefined && !busy ? { 'data-autofocus': '' } : {})}
        >
          {busy ? (
            <>
              <span className="spin" aria-hidden="true" />
              处理中…
            </>
          ) : (
            confirmLabel
          )}
        </button>
      </div>
    </Modal>
  )
}
